import styled from 'styled-components';

export const ContentQuestions = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1em;
  p {
    color: #fff;
    font-size: 1em;
    font-weight: 700;
  }
  .BaSe--accordion {
    border-radius: 100px !important;
    width: 100%;
  }

  .BaSe--accordion-title-container {
    border-top-left-radius: 32px !important;
    border-top-right-radius: 32px !important;
  }

  @media (max-width: 425px) {
    .BaSe--accordion {
      border-radius: 40px !important;
      width: 100%;
    }
  }
`;
export const FrasesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 1.5em;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;
export const FraseItem = styled.p`
  font-size: 1em;
  font-weight: 600;
  color: #fff;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    min-width: 6px;
    background-color: #fff;
    border-radius: 50%;
  }
`;
